"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @index('./*.ts', pp => `import { ${pp.name} } from '${pp.path}';`)

var DxmList_1 = require("./DxmList");

exports.DxmList = DxmList_1.DxmList;

var DxmProvider_1 = require("./DxmProvider");

exports.DxmProvider = DxmProvider_1.DxmProvider;